import {CustomText, H5Text} from '@buncha/components/core/text';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import {Box} from '@buncha/components/core/view';
import {Divider} from 'native-base';
import {GroupedOrder} from '@buncha/driver/types/vanLoadAt';
import {HomeScreens} from '@buncha/home/navigation/types';
import {Modules} from '@buncha/utils/types';
import React from 'react';
import StoreCheckList from '../../vanLoadAt/BuyerOrderList/StoreCheckList';
import {StyleSheet} from 'react-native';
import {useGetLocale} from '@buncha/localization/hooks';

interface CustomerOrdersProps {
  groupedOrderData: GroupedOrder[];
}

const CustomerOrders: React.FC<CustomerOrdersProps> = props => {
  const theme = useColorThemeType('main');
  const muli = useFontTheme('muli');
  const groupedOrders = props?.groupedOrderData[0];
  const orders = groupedOrders?.orders ?? [];
  const buyerDetails = groupedOrders?.buyer;
  const firstName = buyerDetails?.firstName ?? '';
  const lastName = buyerDetails?.lastName ?? '';
  const buyerName = `${firstName} ${lastName}`;
  const {title} = useGetLocale(Modules.driver, HomeScreens.Driver) ?? {};

  return (
    <Box style={styles.parentBox}>
      <Box style={styles.headerBox}>
        <CustomText
          style={[
            styles.customerDetailsText,
            {color: theme?.text?.gray?.[100], fontFamily: muli?.[600]?.normal},
          ]}>
          {title?.customerDetails}
        </CustomText>
        <Divider backgroundColor={'gray.100'} />
      </Box>

      <Box style={styles.CustomerCellBox}>
        <H5Text
          style={[styles.buyerNameText, {color: theme?.text?.blue?.[300]}]}>
          {buyerName}
        </H5Text>
        <StoreCheckList orders={orders} index={0} />
      </Box>
    </Box>
  );
};

export default React.memo(CustomerOrders);

const styles = StyleSheet.create({
  customerDetailsText: {
    textAlign: 'left',
  },
  headerBox: {
    gap: 5,
  },
  CustomerCellBox: {
    gap: 10,
    marginTop: 10,
  },
  buyerNameText: {
    textAlign: 'left',
  },
  parentBox: {
    marginTop: 10,
  },
});
